export default function () {
  return [

    // Lead fields
    { key: 'name', label: 'name' },

  ]
}
